import LogitechLogoSmall from "../assets/logitech/logitech-g-sm.svg";
import LogitechLogoLarge from "../assets/logitech/logitechg.svg";

export const partnerRoute = [
  {
    partner: "logitech",
    route: "logitech-g",
    theme: "theme-logitech",
    logo: {
      small: LogitechLogoSmall,
      large: LogitechLogoLarge,
    },
  },
  {
    partner: "tcl",
    route: "tcl",
    theme: "theme-tcl",
    logo: {
      small: LogitechLogoSmall,
      large: LogitechLogoLarge,
    },
  },
];
